import React, { useState } from 'react'
import { CollectionItem } from 'mytours-read-common'

import { Button, Text, Grid, GridRow, GridCol } from '@mytours/components'

import { getImageAlt } from '../../functions'
import { ImageSizePreset } from '../../../../common_lib/types'
import { generateImageSrcSet, generateImageUrl } from '../../../../common_lib/utils'
import { isRTL } from 'mobile_web/modules/platform'
import classNames from 'classnames'

import './styles/menuListItem.less'

interface Props {
	isActive: boolean
	item: CollectionItem
	onSelect: () => void
}

const MenuListItem: React.FC<Props> = props => {
	const [failedToLoadImage, setFailedToLoadImage] = useState<boolean>(false)

	const clearFailedToLoadImageFlag = () => {
		if (failedToLoadImage) {
			setFailedToLoadImage(false)
		}
	}

	const setFailedToLoadImageFlag = () => {
		if (!failedToLoadImage) {
			// set failed to load to true so we should background of image so user can see there is actually an item (if item has no title too)
			setFailedToLoadImage(true)
		}
	}

	if (!props.item) {
		return null
	}

	const imageObject = props.item.cover_image_grid || props.item.cover_image
	const imageFocalPoint = imageObject?.file?.focal_point
	const imageCrop = imageFocalPoint && (imageFocalPoint[0] !== 0.5 || imageFocalPoint[1] !== 0.5)
	const imageUrl =
		imageObject?.file &&
		generateImageUrl(imageObject?.file, {
			imageSizePreset: ImageSizePreset.Thumbnail,
			crop: imageCrop,
			focalPoint: imageFocalPoint,
		})
	const imageSrcSet =
		imageObject?.file &&
		generateImageSrcSet(imageObject?.file, {
			imageSizePreset: ImageSizePreset.Thumbnail,
			crop: imageCrop,
			focalPoint: imageFocalPoint,
		})

	return (
		// The name and the button role go on the Button below. Held here as well, the row
		// became a control wrapping another control, which leaves the target ambiguous to a
		// screen reader.
		<GridRow
			key={props.item.item_id}
			onClick={props.onSelect}
			className={classNames('menu-list-item', {
				active: props.isActive,
				rtl: isRTL(),
			})}
		>
			<GridCol>
				<Button variant="clear" onClick={props.onSelect} aria-label={props.item.title || ''}>
					<Grid>
						<GridRow>
							{imageUrl && !failedToLoadImage ? (
								<GridCol className="image-col">
									<img
										className="image"
										onLoad={clearFailedToLoadImageFlag}
										onError={setFailedToLoadImageFlag}
										src={imageUrl}
										srcSet={imageSrcSet}
										alt={getImageAlt(imageObject)}
									/>
								</GridCol>
							) : (
								<GridCol className="empty-image" />
							)}
							<GridCol className="titles-container">
								<Text variant="inherit" className="text">
									{props.item.title}
								</Text>
							</GridCol>
						</GridRow>
					</Grid>
				</Button>
			</GridCol>
		</GridRow>
	)
}

export default MenuListItem
